import { Box, Stack, Typography } from "@mui/material";

export default function KeyValItem({
  label,
  val,
  keyWidth = "150px",
  boldLabels = true,
}) {
  const isString = typeof val === "string";

  const labelSx = {
    width: keyWidth,
  };

  if (boldLabels) labelSx.fontWeight = "400";

  return (
    <Stack direction="row">
      <Typography variant="body2" sx={labelSx} component="span">
        {label}:
      </Typography>
      {isString ? (
        <Typography variant="body2" component="span">
          {val}
        </Typography>
      ) : (
        <Box>{val}</Box>
      )}
    </Stack>
  );
}
